import { db } from "../firebaseConfig";
import {
  doc,
  getDoc,
  collection,
  getDocs
} from "firebase/firestore";

export default {
    name: "KnowledgeCentreLogic",
    data() {
      return {
        categories: {},       // { "CategoryName": [ {article}, ... ], ... }
        selectedArticle: null, // The article we show in the right column
        selectedArticleId: null,
        error: null,
        loading: false
      };
    },
    async created() {
      // 1. Fetch all articles and group them by category
      await this.fetchAllArticles();
  
      // 2. If there's an articleId in the route, fetch that article
      const articleId = this.$route.params.articleId;
      if (articleId) {
        await this.fetchArticle(articleId);
      }
    },
    watch: {
      '$route.params.articleId': {
        immediate: false,
        handler(newId) {
          if (newId) {
            this.fetchArticle(newId);
          } else {
            this.selectedArticle = null;
          }
        }
      }
    },
    methods: {
      async fetchAllArticles() {
        this.loading = true;
        try {
          const snapshot = await getDocs(collection(db, "knowledgeBlog"));
          const grouped = {};
          snapshot.forEach(docSnap => {
            const data = docSnap.data();
            const article = {
              id: docSnap.id,
              title: data.title || "",
              category: data.category || "Uncategorized",
              createdBy: data.createdBy || "Anonymous",
              description: data.description || "", // Raw EditorJS JSON string
              timestamp: data.timestamp,
              lastUpdatedTimestamp: data.lastUpdatedTimestamp
            };
            const cat = article.category;
            if (!grouped[cat]) grouped[cat] = [];
            grouped[cat].push(article);
          });
          // Sort each category’s articles by title
          Object.keys(grouped).forEach(cat => {
            grouped[cat].sort((a, b) => a.title.localeCompare(b.title));
          });
          this.categories = grouped;
        } catch (err) {
          console.error("Error fetching articles:", err);
          this.error = "Error fetching articles.";
        } finally {
          this.loading = false;
        }
      },
  
      // <-- This method should be defined separately, not inside fetchAllArticles!
      selectArticle(article) {
        this.selectedArticle = article;
        this.selectedArticleId = article.id;
        // Optionally, navigate to a dedicated route
        // this.$router.push(`/help/read/${article.id}`);
      },
  
      async fetchArticle(articleId) {
        this.loading = true;
        try {
          const articleRef = doc(db, "knowledgeBlog", articleId);
          const docSnap = await getDoc(articleRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            this.selectedArticle = {
              id: articleId,
              title: data.title || "",
              category: data.category || "",
              createdBy: data.createdBy || "",
              description: data.description || "", // Raw EditorJS JSON
              timestamp: data.timestamp,
              lastUpdatedTimestamp: data.lastUpdatedTimestamp
            };
          } else {
            this.selectedArticle = null;
            this.error = "Article not found.";
          }
        } catch (err) {
          console.error("Error fetching article:", err);
          this.error = "Error fetching article.";
        } finally {
          this.loading = false;
        }
      },
  
      goToArticle(article) {
        this.$router.push(`/help/read/${article.id}`);
      },
  
      parseEditorJsBlocks(descriptionJson) {
        try {
          const data = JSON.parse(descriptionJson); // parse the raw JSON
          if (!data.blocks) return "<p>No content</p>";
          let html = "";
          data.blocks.forEach(block => {
            switch (block.type) {
              case "paragraph":
                html += `<p>${block.data.text || ""}</p>`;
                break;
              case "header":
                html += `<h${block.data.level || 2}>${block.data.text || ""}</h${block.data.level || 2}>`;
                break;
              case "image":
                if (block.data.file && block.data.file.url) {
                  html += `<img src="${block.data.file.url}" alt="${block.data.caption || ""}" />`;
                }
                break;
              default:
                html += `<div>[Unsupported block: ${block.type}]</div>`;
            }
          });
          return html;
        } catch (err) {
          console.error("Error parsing EditorJS JSON:", err);
          return "<p>Error loading content</p>";
        }
      }
    }
  };
  